export var officeHomeAppRouteToPath = {
    AppGallery: "/apps/" /* RoutePaths.AppGallery */,
    Browse: "/browse/" /* RoutePaths.Browse */,
    Chat: "/chat/" /* RoutePaths.Chat */,
    CatchUp: "/catchup/" /* RoutePaths.CatchUp */,
    Collect: "/collect/" /* RoutePaths.Collect */,
    ConsumerAllSearch: "/search/main/" /* RoutePaths.ConsumerAllSearch */,
    ConsumerFileSearch: "/search/docs/" /* RoutePaths.ConsumerFileSearch */,
    ConsumerTemplateSearch: "/search/templates/" /* RoutePaths.ConsumerTemplateSearch */,
    Content: "/launch/:app/content/" /* RoutePaths.Content */,
    Copilot: "/copilot/" /* RoutePaths.Copilot */,
    CopilotCmc: "/copilotcmc/" /* RoutePaths.CopilotCmc */,
    Create: "/create/:entityId?/:subEntityId?" /* RoutePaths.Create */,
    Feed: "/feed/" /* RoutePaths.Feed */,
    News: "/news/" /* RoutePaths.News */,
    DevUITool: "/browse/devuitool/" /* RoutePaths.DevUITool */,
    Draft: "/draft/" /* RoutePaths.Draft */,
    M365Apps: "/m365apps/:appId/:entityId?/:subPageId?" /* RoutePaths.M365Apps */,
    ModernMyContent: "/modernmycontent/" /* RoutePaths.ModernMyContent */,
    MyContent: "/mycontent/:entityId?/:subEntityId?" /* RoutePaths.MyContent */,
    OfficeHome: "/" /* RoutePaths.Home */,
    Pages: "/pages/" /* RoutePaths.Pages */,
    People: "/people/" /* RoutePaths.People */,
    Prepare: "/prepare/" /* RoutePaths.Prepare */,
    AiHubSample: "/aiHubSample/" /* RoutePaths.AiHubSample */,
    Assist: "/assist/" /* RoutePaths.Assist */,
    Actions: "/actions/" /* RoutePaths.Actions */,
    BizChat: "/bizchat/" /* RoutePaths.BizChatNative */,
    Workplace: "/workplace/" /* RoutePaths.Workplace */,
    Search: "/search/" /* RoutePaths.Search */,
    SearchPersonScoped: "/search/content/" /* RoutePaths.SearchPersonScoped */,
    SearchPersonScopedOverview: "/search/overview/" /* RoutePaths.SearchPersonScopedOverview */,
    SearchFilesScoped: "/search/files/" /* RoutePaths.SearchFilesScoped */,
    SearchPeopleScoped: "/search/people/" /* RoutePaths.SearchPeopleScoped */,
    SearchSitesScoped: "/search/sites/" /* RoutePaths.SearchSitesScoped */,
    Start: "/launch/:app/" /* RoutePaths.Start */,
    Templates: "/template/:app/" /* RoutePaths.Template */,
    ThemeTest: "/themetest/" /* RoutePaths.ThemeTest */,
};
//# sourceMappingURL=officeHomeAppRouteToPath.js.map